


















import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Popup } from 'vant';
import Dialog from '@/mixins/Dialog';
import Box from '@/components/Box.vue';

@Component({
    components: {
        'van-popup': Popup,
        'box': Box
    }
})
export default class AnswerSuccessDialog extends Mixins(Dialog) {

    //标题
    public title_string: string = '';

    //提示
    @Prop(String)
    public hint_string!: string;

    //分享按键
    public onShareBtn(): void {
        this.$emit("share");
    }
    
    //关闭弹窗
    public closeDialog(): void {
        this.$emit("close");
        this.show = false;
    }
    
    //打开弹窗
    public openDialog(title: string) {
        this.title_string = title;
        this.show = true;
    }
}
